module.exports = __webpack_public_path__ + "static/media/LK_Remove User.e2a3bba7.svg";